angular.module('impactx.treeselect').controller('TreeSelectCtrl', [TreeSelectController]);

function TreeSelectController() {
    var self = this;
    self.tree = angular.copy(self.tree);

    self.zoomOutOfNode = function (entry) {
        var fakeSuperEntry = entry;
        fakeSuperEntry.id = entry.superId;
        self.onLevelChange({selectedNode: fakeSuperEntry});
    };

    self.zoomIntoNode = function (entry) {
        self.onLevelChange({selectedNode: entry});
    };

    self.selectEntry = function (entry) {
        if (self.tree.selected.id !== entry.id) {
            self.onSelectedItemChange({selected: entry});
        }
    };

    self.selectSuperEntry = function (entry) {
        var fakeSuperEntry = entry;
        fakeSuperEntry.id = entry.superId;
        self.onSelectedItemChange({selected: fakeSuperEntry});
    };

    self.removeSelection = function () {
        self.onSelectedItemChange({selected: {id: 0}});
    };
}